/** Graphics presets. "auto" starts from the device and steps down if frames run slow. */
export type QualityName = 'low' | 'medium' | 'high';
export type QualitySetting = QualityName | 'auto';

export interface Quality {
  pixelRatio: number;
  shadows: boolean;
  shadowSize: number;
  foliage: number;
  particles: number;
  /** HDR bloom pass. */
  bloom: boolean;
  /** Real point lights from fires and lamps. */
  lights: number;
  /** Glowing mushrooms in the fen and grove. */
  shrooms: number;
}

export const PRESETS: Record<QualityName, Quality> = {
  low: { pixelRatio: 1, shadows: false, shadowSize: 1024, foliage: 0.3, particles: 0.5, bloom: false, lights: 0, shrooms: 120 },
  medium: { pixelRatio: 1.5, shadows: true, shadowSize: 1024, foliage: 0.65, particles: 0.8, bloom: true, lights: 4, shrooms: 220 },
  high: { pixelRatio: 2, shadows: true, shadowSize: 2048, foliage: 1, particles: 1, bloom: true, lights: 8, shrooms: 320 },
};

export function startingQuality(): QualityName {
  const narrow = window.matchMedia('(max-width: 760px)').matches;
  const cores = navigator.hardwareConcurrency ?? 4;
  if (narrow || cores <= 4) return 'medium';
  return 'high';
}

/** Watches frame times; after a few seconds of slow frames, suggests the next preset down. */
export class AutoQuality {
  private samples: number[] = [];
  private cooldown = 4;
  constructor(public current: QualityName) {}
  /** Returns a new preset when it should change, otherwise null. */
  sample(dt: number): QualityName | null {
    this.cooldown -= dt;
    this.samples.push(dt);
    if (this.samples.length < 120 || this.cooldown > 0) return null;
    const avg = this.samples.reduce((a, b) => a + b, 0) / this.samples.length;
    this.samples = [];
    if (avg > 1 / 38 && this.current !== 'low') { this.current = this.current === 'high' ? 'medium' : 'low'; this.cooldown = 6; return this.current; }
    return null;
  }
}
